import { useEffect, useRef, useState } from "react";
import { galleryItems } from "../../../mocks/home";

const REAL_PHOTO_2 = "https://storage.readdy-site.link/project_files/1dd47190-5ea2-431c-a9ac-432354462ac6/75ebc5fc-d2a0-478f-9d77-eba8f02c82c5_64179567944dbb89ce0fd9b626d3393fd094e8a8.png?v=2ddda1c25cf8eccfdd1662238c56bf29";

const REAL_PHOTO_3 = "https://storage.readdy-site.link/project_files/1dd47190-5ea2-431c-a9ac-432354462ac6/b9139997-39df-458b-8486-4b43cdfa9a0b_5224464aa9bd985acaa9b906992659a1539a3762.png?v=f0018e23e213c3c471b0f64377da771f";

export default function ChallengeGallery() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  const colors = ["bg-[#D4F4E8]", "bg-[#F0F0F0]", "bg-[#FFF3E0]", "bg-[#FFE8EC]"];

  return (
    <section ref={ref} className="bg-[#F2F4F6] py-24 lg:py-32 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div
          className={`mb-14 flex flex-col sm:flex-row sm:items-end justify-between gap-6 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div>
            <span className="text-xs font-semibold tracking-widest text-[#191F28]/40 uppercase mb-3 block">
              매일 성장하는 우리들
            </span>
            <h2 className="text-4xl lg:text-5xl font-black text-[#191F28] leading-relaxed lg:leading-relaxed">
              오늘도 챌린지를
              <br />
              <em className="not-italic text-[#00D873]">완료했어요</em>
            </h2>
          </div>
          <div className="flex items-center gap-2 bg-white px-5 py-3 rounded-full text-sm font-medium text-[#191F28] self-start">
            <span className="w-2 h-2 bg-[#00D873] rounded-full animate-pulse" />
            오늘 3,240개 완료됨
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {galleryItems.map((item, i) => (
            <div
              key={item.id}
              className={`group rounded-3xl overflow-hidden cursor-pointer transition-all duration-500 ${colors[i]} ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              } hover:-translate-y-1`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {/* Image */}
              <div className="relative overflow-hidden" style={{ aspectRatio: "3/4" }}>
                <img
                  src={i === 0 ? REAL_PHOTO_2 : i === 2 ? REAL_PHOTO_3 : item.image}
                  alt={item.challenge}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                {/* Day Badge */}
                <div className="absolute top-3 right-3 bg-white/90 text-[#191F28] text-xs font-bold px-2 py-1 rounded-full">
                  {item.day}일차
                </div>
              </div>

              {/* Info */}
              <div className="p-4 pb-5">
                <div className="text-xs text-[#191F28]/50 mb-2">{item.user}</div>
                <div className="text-sm font-bold text-[#191F28] leading-normal">{item.challenge}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
